module.exports = __webpack_public_path__ + "static/media/bear3.aca3ef1e.PNG";